import v16Schema, {
  MigrationTypes as V16Types,
} from "../client/schemaVersions/v16.js";
import v17Schema, {
  MigrationTypes as V17Types,
} from "../client/schemaVersions/v17.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V16Types, V17Types>(
  v16Schema,
  v17Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
